// src/utils/apiError.js
// Centralized API error handler — extracts a clean message from any axios error.

/**
 * Extract a user-friendly message from an axios error.
 */
export const getErrorMessage = (error) => {
  if (!error) {
    return 'Something went wrong. Please try again.';
  }

  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  if (error.response?.data?.msg) {
    return error.response.data.msg;
  }

  if (error.response?.data?.error) {
    return error.response.data.error;
  }

  if (error.message) {
    return error.message;
  }

  return 'Something went wrong. Please try again.';
};

/**
 * Handles common API errors.
 * Redirects unauthenticated users to login,
 * otherwise shows the API error message.
 */
export const handleApiError = (error, setError) => {
  if (error?.response?.status === 401) {
    window.location.href = '/chaudharylife/login';
    return;
  }

  if (typeof setError === 'function') {
    setError(getErrorMessage(error));
  }
};